module.exports = __webpack_public_path__ + "media/images/invoice-d7655923924c3572a3ac8cb3db7f29b5.jpg";